import loadRoute from 'launch/components/loadRoute';
import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

const LogoProductPackaging = (props: RouteComponentProps) => (
    <Switch>
        <Route
            path={`${props.match.url}/designs`}
            component={loadRoute(
                (done: any) => require(['launch/components/BriefStyleSelector'], done),
                {
                    withStyleAssessment: true,
                }
            )}
        />
        <Route
            path={`${props.match.url}/package-type`}
            component={loadRoute(
                (done: any) => require(['launch/components/BriefPackageType'], done),
                {}
            )}
        />
        <Route
            path={`${props.match.url}/attributes`}
            component={loadRoute(
                (done: any) => require(['launch/components/BriefStyleAttributes'], done),
                {}
            )}
        />
        <Route
            path={`${props.match.url}/colors`}
            component={loadRoute(
                (done: any) => require(['launch/components/BriefStyleColors'], done),
                {}
            )}
        />
        <Route
            path={`${props.match.url}/brief`}
            component={loadRoute(
                (done: any) => require(['launch/components/LogoProductPackagingBrief'], done),
                {}
            )}
        />
        <Redirect from="*" to={{ ...props.location, pathname: `${props.match.url}/designs` }} />
    </Switch>
);

export default LogoProductPackaging;
